// `Data-Region` header value sent to engage-frontend-gateway. EFG accepts
// 'us' | 'ca' | 'uk' (case-insensitive); 'gb' is aliased to 'uk' on the gateway.

export type DataRegion = 'us' | 'ca' | 'uk';

export const DEFAULT_DATA_REGION: DataRegion = 'us';

const COUNTRY_TO_REGION: Record<string, DataRegion> = {
  US: 'us',
  CA: 'ca',
  GB: 'uk',
};

export const countryToDataRegion = (country: string | undefined): DataRegion =>
  (country ? COUNTRY_TO_REGION[country.toUpperCase()] : undefined) ?? DEFAULT_DATA_REGION;
